import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemImportCsvRoute: InvariantJiraRoute = {
	name: 'global-settings-system-import-csv',
	path: '/(secure|secure/admin)/Csv(\\w+)Page([!%]?[\\w]*).jspa',
};
